/**
 * MagSafe cases landing — ensure PhoneMagneticCompat mounts the cases picker.
 */
(function () {
  function boot() {
    var pmc = window.PhoneMagneticCompat;
    if (pmc && typeof pmc.autoInit === 'function') {
      pmc.autoInit();
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
